import React, { useMemo, useEffect, useState } from "react";
import { Box } from "@mui/material";
import Modal from "@mui/material/Modal";
import { styleModalBoxProductos } from "verticales/StylesGene";

function UtilModal(props: any) {
  // const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  // const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  // const setWindowDimensions = () => {
  //   setWindowWidth(window.innerWidth);
  //   setWindowHeight(window.innerHeight);
  // };

  // useEffect(() => {
  //   window.addEventListener("resize", setWindowDimensions);
  //   return () => {
  //     window.removeEventListener("resize", setWindowDimensions);
  //   };
  // }, []);
  return (
    <React.Fragment>
      <Modal
        open={props.openModal}
        onClose={props.handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflow: "auto" }}
      >
        <Box>{props.renderView()}</Box>
      </Modal>
    </React.Fragment>
  );
}

export default UtilModal;
